import React from "react";
import "./CommonModal.scss";

interface CommonModalProps {
  buttonTitle: string;
  title: string;
  modalId: string;
  modalsize?: "auimodal-lg" | "auimodal-md" | "auimodal-sm";
  showCloseButton?: boolean;
  children?: React.ReactNode;
}

const CommonModal: React.FC<CommonModalProps> = ({
  title,
  buttonTitle,
  modalId,
  modalsize = "auimodal-md",
  showCloseButton = true,
  children,
}) => {
  return (
    <div>
      <aui-button
        variant="read-more"
        buttontitle={buttonTitle}
        id={`${modalId}-button`}
        buttonclass="ml-2 font-600 feedback-template-btn mr-2"
        size="medium"
        ifmodal={true}
        modalid={modalId}
      ></aui-button>

      <aui-modal modalsize={modalsize}>
        <div
          className="modal fade auimodal"
          id={modalId}
          aria-labelledby={`${modalId}-label`}
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content d-block p-4 position-relative">
              {showCloseButton && (
                <button
                  type="button"
                  className="close aui-modalclose position-absolute p-1 aui-modalclosecls"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <aui-icon aria-hidden="true" icon="closeIcon" />
                </button>
              )}

              <div className="modal-header border-0 pb-0">
                <h3
                  id={`${modalId}-label`}
                  className="modal-title mb-3 text-center text-lg-left"
                >
                  {title}
                </h3>
              </div>

              <aui-modal-content>
                <div className="modal-body d-block">{children}</div>
              </aui-modal-content>
            </div>
          </div>
        </div>
      </aui-modal>
    </div>
  );
};

export default CommonModal;
